var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-editor-container" },
    [
      _c("data-card", [
        _c("p", { attrs: { slot: "title" }, slot: "title" }, [
          _vm._v(_vm._s(_vm.$t("tableFrom.Welcome"))),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }